import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import './CoursePageLibrary.scss';
import { setCurrentCourse, setCurrentPage, setSidebarRouteData } from "../../../store/actions/mainActions";
import SearchBox from "../../core/SearchBox/SearchBox";
import { useParams} from 'react-router-dom';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { CourseContent } from "../../content/CourseContent/CourseContent";
import DescriptionIcon from "@mui/icons-material/Description";
import VideoLibraryIcon from "@mui/icons-material/VideoLibrary";
import PhotoIcon from "@mui/icons-material/Photo";
import MusicNote from "@mui/icons-material/MusicNote"; // Or any other relevant icon
import eventsService from "../../../Axios/services/events.service";

export const CoursePageLibrary = (props: any) => {
  const dispatch = useDispatch();
  const { id } = useParams();

  const [files, setFiles] = useState<any>(undefined);
  const [filteredFiles, setFilteredFiles] = useState<any>(undefined);
  const [searchInput, setSearchInput] = useState("");
  const [sortBy, setSortBy] = useState<string>("date");
  const [filterBy, setFilterby] = useState<string>("type");
  const [course, setCourse] = useState<any>(undefined);

  const extractFileType = (fileName: string) => {
    return fileName.split(".").pop();
  };

  const renderFileName = (mimeType: any) => {
    switch (mimeType) {
      case "jpg":
      case "jpeg":
      case "png":
      case "gif":
        return "Image";
      case "pdf":
        return "PDF";
      case "mp4":
        return "Video";
      case "mp3":
        return "Audio";
      case "docx":
        return "Word";
      case "pptx":
        return "Power Point";
    }
  };

  const renderFileIcon = (mimeType: any) => {
    switch (mimeType) {
      case "jpg":
      case "jpeg":
      case "png":
      case "gif":
        return (
          <PhotoIcon
            sx={{
              width: "35px",
              height: "35px",
              strokeWidth: 1, // Adjust stroke width (Note: Material-UI icons don't have stroke by default)
            }}
          />
        );
      case "mp4":
        return (
          <VideoLibraryIcon
            sx={{
              width: "35px",
              height: "35px",
              strokeWidth: 1, // Adjust stroke width (Note: Material-UI icons don't have stroke by default)
            }}
          />
        );
      case "mp3":
        return <MusicNote sx={{ width: 35, height: 35 }} />;
      case "pdf":
      case "docx":
      case "pptx":
        return <DescriptionIcon sx={{ width: 35, height: 35 }} />;
    }
  };

  const handleSetSortBy = (sortby: string) => {
    switch (sortby) {
      case "date": {
        const _files: any = filteredFiles.sort((a: any, b: any) => {
          return a.created - b.created;
        });
        setFilteredFiles(_files);
        break;
      }
      case "name": {
        const _files: any = filteredFiles.sort((a: any, b: any) => {
          if (a.title < b.title) {
            return -1;
          }
          if (a.title > b.title) {
            return 1;
          }
          return 0;
        });
        setFilteredFiles(_files);
        break;
      }
      case "":
        setFilteredFiles(files);
        break;
    }
    setSortBy(sortby);
  };

  const handleFilterBy = (filterby: string) => {
    setFilterby(filterby);
  };

  useEffect(() => {
    const getCourse = async () => {
      const id = props.match.params.id;
      const course = await eventsService.getCourse(id);
      if (course) {
        dispatch(setCurrentCourse(course));
        setCourse(course);
      }
    };
    const getFiles = async () => {
      const id = props.match.params.id;
      let files = await eventsService.getCourseContentAttachment(id);
      files = files.map((f: any) => {
        if (f.contentHandler.file) {
          const ext = extractFileType(f.contentHandler.file.fileName);
          return {
            created: new Date(f.created),
            title: f.title,
            type: ext,
            content: f,
            typeName: renderFileName(ext),
            icon: renderFileIcon(ext),
          };
        }
      });
      setFiles(files);
      setFilteredFiles(files);
    };
    const update = async () => {
      await getFiles();
      await getCourse();
    };
    update();

    return () => {
      dispatch(setCurrentCourse(null));
    };
  }, []);

  useEffect(() => {
    dispatch(setCurrentPage("coursePageLibrary"));
    dispatch(setSidebarRouteData({ id }));
    return () => {
      dispatch(setSidebarRouteData({}));
      dispatch(setCurrentPage(""));
    };
  }, [dispatch]);

  const searchHandler = (e: any) => {
    setSearchInput(e.target.value);
  };

  useEffect(() => {
    if (searchInput) {
      const _files = files.filter((f: any) => f.title?.toLowerCase().includes(searchInput.toLowerCase()));
      setFilteredFiles(_files);
    } else {
      setFilteredFiles(files);
    }
  }, [searchInput]);

  const onEnter = () => {};

  return filteredFiles ? (
    <div className="container-fluid course-page-library">
      <div className="mx-md-0">
        <h2 className="mb-3">Material Library</h2>
      </div>
      <div className="mx-md-0">
        <SearchBox placeholder={"Search in library"} changeHandler={searchHandler} onEnter={onEnter} value={searchInput} />
      </div>
      <div className="mx-md-0 data-arrange">
        <div className="row w-100 justify-content-between my-3 mx-0">
          <div className="d-flex align-items-center">
            <div className="">Sort by : </div>
            <FormControl variant="standard" sx={{ m: 1, minWidth: 120 }}>
              <Select labelId="sortby" id="demo-simple-select-standard" value={sortBy} onChange={(e) => handleSetSortBy(e.target.value)} label="Age">
                <MenuItem value="">
                  <em>None</em>
                </MenuItem>
                <MenuItem value={"date"}>Date</MenuItem>
                <MenuItem value={"name"}>Name</MenuItem>
              </Select>
            </FormControl>
          </div>
          <div className="d-flex align-items-center">
            <div className="">Filter by : </div>
            <FormControl variant="standard" sx={{ m: 1, minWidth: 120 }}>
              <Select labelId="filterby" id="demo-simple-select-standard" value={filterBy} onChange={(e) => handleFilterBy(e.target.value)} label="Age">
                <MenuItem value="">
                  <em>None</em>
                </MenuItem>
                <MenuItem value={"type"}>Type</MenuItem>
              </Select>
            </FormControl>
          </div>
        </div>
      </div>
      <div className="mx-mx-0">
        <div className="d-flex flex-wrap">
          {filteredFiles.map((f: any) => (
            <div className="mb-4 mr-3">
              <CourseContent content={f} course={course}></CourseContent>
            </div>
          ))}
        </div>
      </div>
    </div>
  ) : (
    <div> loading... </div>
  );
};
